import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";

const STATUSES = ["new", "screening", "shortlisted", "interview", "offered", "hired", "rejected"];
const COLORS = {
  new: "border-blue-200 bg-blue-50",
  screening: "border-amber-200 bg-amber-50",
  shortlisted: "border-purple-200 bg-purple-50",
  interview: "border-indigo-200 bg-indigo-50",
  offered: "border-emerald-200 bg-emerald-50",
  hired: "border-green-200 bg-green-50",
  rejected: "border-rose-200 bg-rose-50",
};

export default function AdminPipeline() {
  const [data, setData] = useState({});

  const load = () => api.get("/admin/applications/pipeline").then((r) => setData(r.data));
  useEffect(() => { load(); }, []);

  const move = async (id, to) => {
    try {
      await api.patch(`/admin/applications/${id}/status`, { status: to });
      toast.success(`Moved to ${to}`);
      load();
    } catch {
      toast.error("Failed to move");
    }
  };

  return (
    <div className="space-y-6" data-testid="admin-pipeline">
      <div>
        <h1 className="font-heading text-2xl font-semibold text-slate-900">Application Pipeline</h1>
        <p className="text-sm text-slate-500">Move candidates through your hiring stages.</p>
      </div>
      <div className="grid gap-3 lg:grid-cols-7">
        {STATUSES.map((s) => (
          <div key={s} className={`rounded-lg border ${COLORS[s]} p-3`} data-testid={`pipeline-col-${s}`}>
            <div className="mb-3 flex items-center justify-between">
              <div className="text-xs font-bold uppercase tracking-wider text-slate-700">{s}</div>
              <Badge variant="secondary" className="bg-white">{(data[s] || []).length}</Badge>
            </div>
            <div className="flex flex-col gap-2">
              {(data[s] || []).map((a) => (
                <div key={a.id} className="rounded border border-slate-200 bg-white p-3 shadow-sm" data-testid={`pipeline-card-${a.id}`}>
                  <div className="text-sm font-semibold text-slate-900">{a.candidate_name}</div>
                  <div className="text-xs text-slate-500">{a.job_title || "General"}</div>
                  <div className="text-[10px] uppercase tracking-wider text-slate-400">{a.experience_years} yrs · {a.location || "—"}</div>
                  <Select value={a.status} onValueChange={(v) => move(a.id, v)}>
                    <SelectTrigger className="mt-2 h-7 text-xs" data-testid={`pipeline-status-${a.id}`}><SelectValue /></SelectTrigger>
                    <SelectContent>{STATUSES.map((x) => <SelectItem key={x} value={x}>{x}</SelectItem>)}</SelectContent>
                  </Select>
                </div>
              ))}
              {(data[s] || []).length === 0 && (
                <div className="rounded border border-dashed border-slate-300 p-3 text-center text-xs text-slate-400">Empty</div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
